<template>
  <v-dialog :value="dialog" max-width="500px" @input="onDialogInput">
    <v-card dark class="delete-dialog-card">
      <div class="danger-icon">
        <v-icon size="30" color="error">mdi-trash-can-outline</v-icon>
      </div>

      <v-card-title class="dialog-title">Ordner wirklich löschen?</v-card-title>
      <v-card-text class="dialog-copy">
        <p>
          Der Ordner <strong>„{{ folder.name }}“</strong> und alle enthaltenen Unterordner werden gelöscht.
        </p>
        <div class="consequence-note">
          <v-icon small color="warning">mdi-information-outline</v-icon>
          <span>Die Dokumente selbst bleiben erhalten und werden zurück in den Eingang verschoben.</span>
        </div>
      </v-card-text>

      <v-card-actions class="dialog-actions">
        <v-btn text class="secondary-button" @click="$emit('cancel-delete')"> Abbrechen </v-btn>
        <v-btn color="error" depressed class="danger-button" @click="$emit('confirm-delete')">
          <v-icon left small>mdi-trash-can-outline</v-icon>
          Ordner löschen
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DeleteFolderDialog",
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    folder: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onDialogInput(value) {
      if (!value) this.$emit("cancel-delete")
    },
  },
}
</script>

<style scoped>
.delete-dialog-card {
  --dialog-bg: rgba(28, 28, 29, 0.97);
  --dialog-border: rgba(255, 255, 255, 0.1);
  --dialog-text: #f5f5f5;
  --dialog-muted: #a3a3a3;
  padding: 26px;
  overflow: hidden;
  border: 1px solid rgba(248, 113, 113, 0.22);
  border-radius: 22px !important;
  background: linear-gradient(150deg, rgba(239, 68, 68, 0.045), transparent 44%), var(--dialog-bg) !important;
  backdrop-filter: blur(22px);
  box-shadow: 0 28px 80px rgba(0, 0, 0, 0.46);
}

.danger-icon {
  display: grid;
  width: 58px;
  height: 58px;
  margin-bottom: 14px;
  place-items: center;
  border: 1px solid rgba(248, 113, 113, 0.22);
  border-radius: 18px;
  background: rgba(239, 68, 68, 0.1);
}

.dialog-title {
  padding: 0 0 9px !important;
  color: var(--dialog-text);
  font-size: 1.18rem !important;
  font-weight: 800;
  letter-spacing: -0.015em;
}

.dialog-copy {
  padding: 0 !important;
  color: var(--dialog-muted) !important;
  font-size: 0.84rem;
  line-height: 1.65;
}

.dialog-copy p {
  margin: 0;
}

.dialog-copy strong {
  color: var(--dialog-text);
}

.consequence-note {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  margin-top: 17px;
  padding: 13px 14px;
  border: 1px solid rgba(251, 191, 36, 0.2);
  border-radius: 14px;
  background: rgba(245, 158, 11, 0.07);
  color: #d4d4d4;
  font-size: 0.76rem;
  line-height: 1.5;
}

.dialog-actions {
  justify-content: flex-end;
  gap: 8px;
  padding: 24px 0 0 !important;
}

.danger-button,
.secondary-button {
  min-height: 44px !important;
  border-radius: 13px !important;
  font-weight: 750;
  letter-spacing: 0;
  text-transform: none;
}

@media (max-width: 599px) {
  .delete-dialog-card {
    margin: 8px;
    padding: 21px;
    border-radius: 20px !important;
  }

  .dialog-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .dialog-actions .v-btn {
    min-width: 0 !important;
    padding: 0 10px !important;
  }
}
</style>
